import { useNotify } from 'react-admin';
import { IconButton } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyButton = ({ copyText, sx = {} }) => {
  const notify = useNotify();

  async function copyToClipboard() {
    try {
      await navigator.clipboard.writeText(copyText);
      notify(`Copied text to clipboard!`);
    } catch (err) {
      notify('Could not copy text to clipboard.\nCheck console for error details.');
      console.error(err);
    }
  }

  return (
    <IconButton
      aria-label="copy name"
      onClick={copyToClipboard}
      size="small"
      color="secondary"
      sx={sx}
    >
      <ContentCopyIcon fontSize="small" />
    </IconButton>
  );
}

export default CopyButton;
